
// helper_getPercentage_n
const {FB_Cost} = require( "./Share_S_Classes");
const {
    enum_accessLevelOptions,
    enum_directions,
    enum_featuresMinPoints,
    enum_langCodes,
    enum_moreInfo_featuresIds_s
} = require( "./Share_S_Enum");
const {obj_forEach_f} = require( "./Share_S_Obj");

// helper_getPercentage_n
export const helper_getPercentage_n = (val, percentage) =>{
    return (val * percentage) / 100
}

// helper_arrToObj_fo
export const helper_arrToObj_fo = (arr_a, value_f) => {
    let ans  = {}

    obj_forEach_f(arr_a, (item) => {
        ans[item] = value_f(item)

    })

    return ans
}

// helper_getDisplayLang_e
export const helper_getDisplayLang_e = (systemLangCode, langArr, mainLang) => {

    if(langArr == null || mainLang == null){
        return systemLangCode
    }

    if(langArr.indexOf(systemLangCode) > -1){
        return systemLangCode
    }else {
        return mainLang
    }

}

// helper_getDirectionByLangCode_e
export const helper_getDirectionByLangCode_fe = (langCode ) => {
    switch(langCode){
        case enum_langCodes.english:
        case enum_langCodes.spanish:
        case enum_langCodes.french:
            return enum_directions.ltr
        case enum_langCodes.hebrew:
            return enum_directions.rtl
        default:
            return enum_directions.ltr
    }
}

// helper_getCost (COPY TO BACKEND)
export const helper_realCost_c = (purchasedBy_e, cost_c, tqProfitPercentage_n) => {

    let ansCost_c = new FB_Cost({});
    switch(purchasedBy_e){
        case enum_accessLevelOptions.admin:
            ansCost_c.c_value_n = 0
            break;
        case enum_accessLevelOptions.creator:
            ansCost_c.c_value_n = helper_getPercentage_n(cost_c.c_value_n, tqProfitPercentage_n)
            break;
        default :
            ansCost_c.c_value_n = cost_c.c_value_n
    }

    return ansCost_c
}

// random4Digits
export const help_random4Digits = () => {
    return Math.floor(1000 + Math.random() * 9000);
}

// help_maxDurationTime_f
export const help_maxDurationTime_f = (creatorPoints_n) => {

    if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_7Days]) {
        return 60 * 24 * 7
    }else if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_7Days]) {
        return 60 * 24 * 7
    }else if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_3Days]){
        return 60*24*3
    }else if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_24Hour]) {
        return 60 * 24
    }else if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_12Hour]){
        return 60*12
    }else if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_6Hour]){
        return 60*6
    }else if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_3Hour]){
        return 60*3
    }else if(creatorPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_duration_2Hour]){
        return 60*2
    }else{
        return 60*2
    }




}
// helper_getObjInArray_fo
export const helper_getObjIndexInArray_fn = (arr_a, attName_s, value) => {
    return arr_a.map((item) => {
        return item[attName_s]
    }).indexOf(value)
}


export const helper_distanceTwoPointsMeters_fn = ({lat1, lon1, lat2, lon2}) => {

    // Converts numeric degrees to radians
    function toRad(Value) {
        return Value * Math.PI / 180;
    }

    const R = 6371*1000; // meters
    const dLat = toRad(lat2-lat1);
    const dLon = toRad(lon2-lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const d = R * c;

    return d.toFixed(0)

}